'use client';

import { inter500 } from '@/config/fonts';
import { selectCurrentAccountId } from '@/lib/redux/app.selectors';
import { Account } from '@/lib/redux/app.slice';
import LabelBadge from '@/shared/components/LabelBadge';
import classNames from 'classnames';
import { HTMLAttributes, ReactNode } from 'react';
import { useSelector } from 'react-redux';

interface AccountItemViewProps extends HTMLAttributes<HTMLDivElement> {
  data: Account;
  actions?: ReactNode;
}

const AccountItemView = ({ className, data, actions, style }: AccountItemViewProps) => {
  const currentAccountId = useSelector(selectCurrentAccountId);
  const displayName = data.account_name || data.account_id || 'Unknown Account';

  // Current account is always considered "Root" in this context
  // Sub-accounts of the current account are labeled "Sub"
  const isCurrentAccount = data.account_id === currentAccountId;
  const accountTypeBadge = isCurrentAccount ? 'Root' : 'Sub';
  const badgeColor = isCurrentAccount ? 'blue' : 'purple';

  return (
    <div
      className={classNames('flex items-center justify-between', className)}
      style={style}>
      <div className="flex w-full items-center gap-3">
        <div className="flex flex-1 flex-col gap-0.5">
          <span className={classNames(inter500.className)}>{displayName}</span>
          <span
            className={classNames('text-gray-default text-[13px] dark:text-gray-400')}>
            ID: {data.account_id}
          </span>
        </div>
        <div className="mx-auto">
          <LabelBadge color={badgeColor}>{accountTypeBadge}</LabelBadge>
        </div>
        <div className="actions flex shrink-0 items-center gap-2">{actions}</div>
      </div>
    </div>
  );
};

export default AccountItemView;
